import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { VALIDATIONS } from 'src/app/shared/models/validation.regex';
import { AuthService } from 'src/app/shared/providers/auth/auth-service.service';
import { NafathRandomVMResponseModel } from '../../models/nafathRandomVMResponseModel';
import { GetRandomNafathAuthQuery } from '../../models/getRandomNafathAuthQuery';
import { HttpErrorResponse } from '@angular/common/http';
import { CheckNafathAuth } from 'src/app/shared/models/checkNafathAuth';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nafath-login',
  templateUrl: './nafath-login.component.html',
  styleUrls: ['./nafath-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NafathLoginComponent implements OnInit, OnDestroy {
  private intervalSubscription?: Subscription;
  private cdr = inject(ChangeDetectorRef);
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private toastr = inject(ToastrService);
  private translate = inject(TranslateService);
  private router = inject(Router);

  dir = "ar";
  countdown: number = 60;
  loginForm!: FormGroup;
  isNafathLogin = false;
  nafathLoginData: NafathRandomVMResponseModel = {};
  running = false;
  remainingTime = 5;

  constructor() {}

  ngOnInit(): void {
    const urlPath = this.router.url.split('/');
    const langInUrl = urlPath.find(segment => segment === 'ar' || segment === 'en') || 'ar';
    
    this.translate.use(langInUrl).subscribe(() => {
      this.updateDirection(langInUrl);
      this.cdr.markForCheck();
    });

    this.initForm();
  }

  changeLanguage() {
    const currentLang = this.translate.currentLang || 'ar';
    const nextLang = currentLang === 'ar' ? 'en' : 'ar';

    this.translate.use(nextLang).subscribe(() => {
      const url = this.router.url.replace(`/${currentLang}`, `/${nextLang}`);
      this.router.navigateByUrl(url);
      this.updateDirection(nextLang);
      this.cdr.markForCheck();
    });
  }

  private updateDirection(lang: string) {
    sessionStorage.setItem('lang', lang);
    this.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', this.dir);
    document.documentElement.setAttribute('lang', lang);
  }

  initForm() {
    this.loginForm = this.fb.group({
      nationalId: ['', [Validators.required, Validators.pattern(VALIDATIONS.NUMBERS_ONLY), Validators.maxLength(10)]]
    });
  }

  get formControls() {
    return this.loginForm.controls;
  }

  reset() {
    this.loginForm.reset();
    this.isNafathLogin = false;
    this.stopTimer();
    this.cdr.markForCheck();
  }

  startTimer(): void {
    if (this.running) return;
    this.countdown = 60;
    this.remainingTime = 5;
    this.running = true;

    this.intervalSubscription = interval(1000).subscribe(() => {
      this.countdown--;
      this.remainingTime--;

      if (this.countdown <= 0) {
        this.stopTimer();
        this.cdr.markForCheck();
        return;
      }

      if (this.remainingTime <= 0) {
        this.checkNafathAuthentication();
        this.remainingTime = 5;
      }
      this.cdr.markForCheck();
    });
  }

  stopTimer(): void {
    this.intervalSubscription?.unsubscribe();
    this.running = false;
  }

  formatErrors(errors: any): string {
    if (!errors) return 'An unknown error occurred';
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) return errors.join(', ');
    return JSON.stringify(errors);
  }

  nafathLogin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const payload: GetRandomNafathAuthQuery = {
      nationalId: this.formControls['nationalId'].value!,
    };
    
    // this.authService.postNafathLogIn(payload).subscribe({
    //   next: (res: any) => {
    //     if (res?.data?.random && res?.data?.transId) {
    //       this.isNafathLogin = true;
    //       this.nafathLoginData = res;
    //       this.startTimer();
    //     } else {
    //       this.toastr.error(this.formatErrors(res?.errors), 'خطأ');
    //     }
    //     this.cdr.markForCheck();
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     this.toastr.error(this.formatErrors(error?.error?.Message || 'حدث خطأ'), 'خطأ');
    //     this.cdr.markForCheck();
    //   }
    // });
  }

  checkNafathAuthentication() {
    const payload: CheckNafathAuth = {
      nationalId: this.formControls['nationalId'].value!,
      random: this.nafathLoginData.data?.random,
      transId: this.nafathLoginData.data?.transId,
    };

    // this.authService.postCheckNafathAuth(payload).subscribe({
    //   next: (res: any) => {
    //     if (res.data?.status === 'COMPLETED') {
    //       this.stopTimer();
    //     }
    //     this.cdr.markForCheck();
    //   },
    //   error: (error: HttpErrorResponse) => {
    //     this.toastr.error(this.formatErrors(error?.error?.Message), 'خطأ');
    //     this.stopTimer();
    //     this.cdr.markForCheck();
    //   }
    // });
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }
}